import React from 'react';

import { Footer, Possibility, Header, FindPlace, PopularPlace } from '../../containers/index';
import { Navbar } from '../../components';

import '../../App.css';

const Index = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    {/* <WhatGPT3 /> */}
    {/* <Features /> */}
    <Possibility />
    <FindPlace />
    {/* <CTA /> */}
    <PopularPlace />
    <Footer />
  </div>
);

export default Index;
